import { createTheme } from '@mui/material/styles'

export const baseTheme = createTheme({
  ...{
    typography: {
      fontFamily: ['Roboto', 'Arial', '-apple-system', 'sans-serif'].join(','),
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightBold: 700,
      h1: {
        fontSize: '60px',
        lineHeight: '52px',
        fontWeight: 300,
        letterSpacing: '-0.5px'
      },
      h2: {
        fontSize: '48px',
        lineHeight: '62px',
        fontWeight: 300
      },
      h3: {
        fontSize: '40px',
        lineHeight: '48px',
        fontWeight: 400,
        letterSpacing: '0.25px'
      },
      h3Bold: {
        fontSize: '40px',
        lineHeight: '48px',
        fontWeight: 700,
        letterSpacing: '0.25px'
      },
      h4: {
        fontSize: '32px',
        lineHeight: '40px',
        fontWeight: 400,
        letterSpacing: '0.25px'
      },
      h4Bold: {
        fontSize: '32px',
        lineHeight: '40px',
        fontWeight: 700,
        letterSpacing: '0.25px'
      },
      h5: {
        fontSize: '24px',
        lineHeight: '32px',
        fontWeight: 400
      },
      h5Bold: {
        fontSize: '24px',
        lineHeight: '32px',
        fontWeight: 700,
        letterSpacing: '0.25px'
      },
      h6: {
        fontSize: '20px',
        lineHeight: '24px',
        fontWeight: 400,
        letterSpacing: '0.25px'
      },
      h6Bold: {
        fontSize: '20px',
        lineHeight: '24px',
        fontWeight: 700,
        letterSpacing: '0.25px'
      },
      h7Bold: {
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 700,
        letterSpacing: '0.25px'
      },
      body1Light: {
        fontSize: '16px',
        lineHeight: '20px',
        fontWeight: 300,
        letterSpacing: '0.5px'
      },
      body1: {
        fontSize: '16px',
        lineHeight: '20px',
        fontWeight: 400,
        letterSpacing: '0.5px'
      },
      body1Bold: {
        fontSize: '16px',
        lineHeight: '20px',
        fontWeight: 700,
        letterSpacing: '0.5px'
      },
      body2: {
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 400,
        letterSpacing: '0.25px'
      },
      body2Bold: {
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 700,
        letterSpacing: '0.25px'
      },
      button: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 500,
        letterSpacing: '0.04em'
      },
      captionLight: {
        fontSize: '12px',
        lineHeight: '14px',
        fontWeight: 300,
        letterSpacing: '0.4px'
      },
      caption: {
        fontSize: '12px',
        lineHeight: '14px',
        fontWeight: 400,
        letterSpacing: '0.4px'
      },
      captionBold: {
        fontSize: '12px',
        lineHeight: '14px',
        fontWeight: 700,
        letterSpacing: '0.4px'
      },
      overline: {
        fontSize: '12px',
        lineHeight: '14px',
        fontWeight: 400,
        letterSpacing: '1.2px'
      },
      overlineBold: {
        fontSize: '12px',
        lineHeight: '14px',
        fontWeight: 700,
        letterSpacing: '1.2px'
      },
      tooltip: {
        fontSize: '12px',
        lineHeight: '14px',
        fontWeight: 400,
        letterSpacing: '0.4px'
      }
    },
    breakpoints: {
      values: {
        mobile: 360,
        tablet: 768,
        notebook: 1024,
        ultrawide: 1800
      }
    }
  }
})
